import { render, staticRenderFns } from "./WebsitePublicPlaceEditListItem.vue?vue&type=template&id=bb3d23d8&scoped=true&lang=pug"
import script from "./WebsitePublicPlaceEditListItem.vue?vue&type=script&lang=ts"
export * from "./WebsitePublicPlaceEditListItem.vue?vue&type=script&lang=ts"
import style0 from "./WebsitePublicPlaceEditListItem.vue?vue&type=style&index=0&id=bb3d23d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d23d8",
  null
  
)

export default component.exports